import { FC } from "react";
import Container from "react-bootstrap/Container";
import { FaPlus } from "react-icons/fa";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { companiesRoute, createCompanyRoute } from "app/route/Routes";
import { Toolbar, ToolbarButtons, ToolbarTitle } from "app/component/util/Toolbar";
import { createCompanyRole } from "app/api/graph/roles";
import { CompaniesTable } from "app/component/company/CompaniesTable";
import { useAuth } from "app/api/AuthContext";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { ButtonLink } from "app/component/button/ButtonLink";

export const CompaniesListScreen: FC = () => {
    const { roles } = useAuth();
    return (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={companiesRoute} />
                <Toolbar>
                    <ToolbarTitle>
                        <h1>Companies</h1>
                    </ToolbarTitle>
                    <ToolbarButtons>
                        {roles?.includes(createCompanyRole) ? (
                            <ButtonLink to={createCompanyRoute.build({})} variant="success">
                                <FaPlus /> New company
                            </ButtonLink>
                        ) : null}
                    </ToolbarButtons>
                </Toolbar>
                <CompaniesTable />
            </Container>
        </NavigationScreen>
    );
};
